import { createSelector } from 'reselect';

export const BeneficiariesSelector = (state) => state.beneficiaries;

export const getBeneficiariesAccounts = createSelector(
    [BeneficiariesSelector],
    (state) => state.beneficiariesAccounts
);
